import { schemeCategory10, schemeObservable10 } from 'd3';

export const colorscheme = [...schemeCategory10, ...schemeObservable10, '#000000'];
